/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 3V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 16L16 21M21 16L16 11M21 16H9.4C7.15979 16 6.03968 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V9.5V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M21 16L16 21M21 16L16 11M21 16C18.1926 16 13.3531 16 9.39883 16C7.1594 16 6.03968 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M21 16L16 21M21 16L16 11M21 16C18.1926 16 13.3531 16 9.39883 16C7.1594 16 6.03968 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 21L18.5 18.5M16 11L21 16C18.1926 16 13.3531 16 9.39883 16C7.1594 16 6.03968 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 16L16 21M21 16L16 11M21 16C18.1926 16 13.3531 16 9.39883 16C7.1594 16 6.03968 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M21 16L16 21M21 16L16 11M21 16C18.1926 16 13.3531 16 9.39883 16C7.1594 16 6.03968 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
